<template>
    <div>
        <!-- <smallbutton @click="update()" :toplabel="updateText" :class="buttonclass"/> -->
        <!-- ACCT NOTE MODAL -->
          <actionmodal ref="mymodal"> 
            <template v-slot:body>
                <form ref="myform">
                    <label class="titlelabel">{{updateText}}</label>
                    
                    <optionbutton :itemList="tableOptions"  @select="selTableOption" :initialSelectedId="tableSelectedOption" @click.stop="clickedbox"/>

                    <div class="entry" >
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="isactivecheck">Is Active</label>
                        </div>
                        <div class="entryTextDiv">
                            <input id="isactivecheck" class="entryCheckbox" type="checkbox" v-model="table.isActive" @click.stop="clickedbox" >
                        </div>
                    </div>
                    
                    <formentry  inputtype="text"  label="Number"  v-model="table.tableNumber"  :isRequired="paramTrue" @click.stop="clickedbox" v-if="!table.isTextbox"/>
                    <formentry  inputtype="text"  label="Text"  v-model="table.text"  :isRequired="paramTrue" @click.stop="clickedbox" v-if="table.isTextbox"/>
                    <formentry  inputtype="text"  label="Seats"  v-model="table.seatsAvailable"  :isRequired="paramTrue" @click.stop="clickedbox" v-if="!table.isTextbox"/>
                    <formentry  inputtype="text"  label="Width"  v-model="table.sizeX"  :isRequired="paramTrue" @click.stop="clickedbox"/>
                    <formentry  inputtype="text"  label="Length"  v-model="table.sizeY"  :isRequired="paramTrue" @click.stop="clickedbox"/>

                    
    
                    <div v-if="!showConfirmRemove" class="horizFlexStretch">
                        <div>
                            <smallbutton v-if="table.id>0"  @click.stop="showConfirmRemove=true" toplabel="Remove Table" buttonclass="button buttoncancel"/>
                        </div>
                        
                        <div>
                            <smallbutton  @click.stop="save()" toplabel="Save" buttonclass="button buttonsave"/>
                            <smallbutton  @click.stop="cancelupdate()" toplabel="Cancel" buttonclass="button buttoncancel"/>
                        </div>
                            

                    </div>

                    <div v-if="showConfirmRemove">
                        <label class="responsemessage" >Are you sure you want to remove this table?</label>
                        <div>
                            <smallbutton  @click.stop="remove()" toplabel="Remove" buttonclass="button buttonsave"/>
                            <smallbutton  @click.stop="showConfirmRemove=false" toplabel="Cancel" buttonclass="button buttoncancel"/>
                        </div>
                        
                    </div>
                    
                    <div>
                        <label class="responsemessage">{{message}}</label>
                   </div>
              </form>
            </template>
          </actionmodal>
        </div>
    </template>
    
    <script>
    import {mapFields} from 'vuex-map-fields'
    import datamethods from '../../services/datamethods.js'
    import smallbutton from '../controls/button.vue'
    import actionmodal from '../controls/actionmodal.vue'
    import formentry from '../controls/entry.vue'
    import linkbutton from '../controls/linkbutton.vue'
    import pencilbutton from '../controls/pencilbutton.vue'
    import optionbutton from '../controls/optionbutton.vue'
    export default {
        name:'updatetable',
        components:{
            smallbutton,
            actionmodal,
            formentry,
            linkbutton,
            pencilbutton,
            optionbutton
        },
        props:{
            inTable:{
                type:Object,
                required:true
            },
            tables:{
                type:Array,

            },
            isAdd:{
                type:Boolean,
                default:false
            },
            buttonclass:{
                type:String,
                default:'updatebutton'
            },
            locationId:{
                type:Number,
                default:0
            },
            inPosX:{
                type:Number,
                default:1
            },
            inPosY:{
                type:Number,
                default:1
            },
            defaultTableNumber:{
                type:Number,
                default:1
            },
            gridSize:{
                type:Number,
                default:24
            }
            
    
        },
        mixins:[datamethods],
        data(){
            return{
                message:'',
                paramTrue:true,
                paramFalse:false,
                table:null,
                tableOptions:[
                    {
                        id:0,
                        name:'Table'
                    },
                    {
                        id:1,
                        name:'Text Box'
                    }
                ],
                tableSelectedOption:0,
                showConfirmRemove:false
                    
            }
        },
        computed:{
            ...mapFields([
               'loggedInUser'
            ]),
          
            updateText(){
                if(this.isAdd){
                    return "Add Table"
                }else{
                    return "Update Table" 
                }
                
            },
           
          
        },
        methods:{
            selTableOption(id,name){
                if(id==0){
                    //table
                    this.table.isTextbox=false

                }else{
                    this.table.isTextbox=true
                    //update table number
                    this.table.tableNumber = this.getNextTextBoxTableNumber()

                }
            
            },
            getNextTextBoxTableNumber(){
                //get next one after biggest TEXT BOX ONE.  Start at 500
                var max=500
                this.tables.forEach(myFunction2)
                        function myFunction2(item, index, arr) {
                        let t=arr[index]
                        if(t.tableNumber>max && t.isTextbox){   
                            max=t.tableNumber
                        } 
                    }
                return max+1
            },
            numberUsed(){
                var thisnum = this.table.tableNumber
                var thisid = this.table.id
                var isUsed = false
                this.tables.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                    let t=arr[index]
                    if(t.tableNumber==thisnum && thisid !=t.id ){   
                        isUsed=true
                    } 
                }
                return isUsed
            },
            clickedbox(){

            },
           update(){
            this.message=null
            this.showConfirmRemove=false
            if(this.isAdd){
                console.log(this.inPosX + ' ' + this.inPosY)
                this.table = {
                     id:-1,
                     locationId:this.locationId,
                     tableNumber: this.defaultTableNumber, 
                     positionX: this.inPosX, 
                     positionY: this.inPosY, 
                     sizeX: 2, 
                     sizeY: 2,
                     seatsAvailable:2,
                     isActive:true 
              
                }
                this.tableSelectedOption=0
     
            }
            else{ 
                this.table = this.inTable
                if(this.table.isTextbox){this.tableSelectedOption=1}else{this.tableSelectedOption=0}
            }
            console.log('ready to open')
            this.$refs.mymodal.openModal()
           },
           
            cancelupdate(){
                this.$emit('cancelupdate')
                this.$refs.mymodal.closeModal()
                
                
            },
            async save(){
                if(this.$refs.myform.checkValidity()==false){
                    this.message = "Please fill in all required fields"
                    return}

                //make sure we aren't going off the end
                if(Number(this.table.positionX) + Number(this.table.sizeX) -1 > this.gridSize){
                    this.message = "The width will make the table go off the edge of the grid. Please enter a smaller width."
                    return
                }
                if(Number(this.table.positionY) + Number(this.table.sizeY) -1 > this.gridSize){
                    this.message = "The length will make the table go off the edge of the grid. Please enter a smaller length."
                    return
                }

                if(this.thisTableOverlapsAnotherTable()){
                    console.log('tell someone about the overlap')
                    this.message = "This table overlaps another table. Please check your width and length."
                    return
                }
                if(this.table.sizeX<2 || this.table.sizeY <2){
                    this.message = "Please enter a length and width greater than or equal to 2"
                    return
                }
                if(this.numberUsed()){
                    this.message="Table number " + this.table.tableNumber + " already exists. Please use a different number."
                    return
                }


                this.$emit('savetable',this.table)
                this.$refs.mymodal.closeModal()
               
            },
            async remove(){
                this.$emit('removetable',this.table)
                this.$refs.mymodal.closeModal()
            },
            thisTableOverlapsAnotherTable(){
                var overlap=false
                console.log('MY TABLE ' + this.table.positionX +  ' ' + this.table.positionY + ' ' + this.table.sizeX + ' ' + this.table.sizeY)

                var sX = Number(this.table.sizeX)
                var sY = Number(this.table.sizeY)

                outerLoop:
                for (let i = this.table.positionX; i <= this.table.positionX + sX-1; i++) {
                    console.log(i + ' ' + sX)
                    for (let j = this.table.positionY; j <= this.table.positionY + sY-1; j++) {
                        if(this.squareIsInAnotherTable(this.table.id,i,j)){
                            console.log('we overlap someone!!')
                            overlap= true
                            break outerLoop;
                        }
                    }
                }
                return overlap //we made it here..no overlap
            },
            squareIsInAnotherTable(tableid, testx, testy){
                var inAnother=false
               console.log('test table ' +  testx + ' ' + testy)
                this.tables.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                    let t=arr[index]
                    if(t.id!=tableid){
                       // console.log(t.positionX +  ' ' + t.positionY + ' ' + t.sizeX + ' ' + t.sizeY)
                        outerLoop:
                        for (let i = t.positionX; i <= t.positionX + t.sizeX-1; i++) {
                            for (let j = t.positionY; j <= t.positionY + t.sizeY-1; j++) {
                               // console.log('i2, j2 ' + i + ' ' + j)
                                
                                if(i==testx && j==testy){
                                    console.log('MATCH!!!! ' + testx + ' ' + testy )
                                    inAnother= true
                                    break outerLoop;
                                    
                                }
                            }
                        }
                    }
                     
                }
                return inAnother //if we made it here there wasn't a match
            }
        }
    }
    </script>
    
    <style>
    .entryCheckLabel{
        margin:0px 0px 0px 5px;
        font-size:medium;
        text-align: left;  
        max-width: 420px;
    }
    .entryCheckLabelbold{
        margin:0px 0px 0px 5px;
        font-size:medium;
        text-align: left;  
        max-width: 420px;
        font-weight:bold;
    }
    .updatebutton{
        height:30px;
        width:150px;
        border-radius: 5px;
        padding:3px;
        margin:0px 0px 10px 0px;
    }
    .locationcheck{
    height:15px;
    margin-top:15px;
    margin-right:5px;
}
.locationdiv{
    text-align: left;
    display:grid;
    grid-template-columns: 1fr 15fr;
}
.locationCheckbox{
    height:15px;
    margin-top:15px;
}
.clarify{
    font-size:smaller;
    text-align:left;
    margin:0px 0px 15px 0px;
}
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    